/// <reference path="../../../typings/index.d.ts" />
/// <reference path="../apimodel.d.ts" />
/// <reference path="../common/routesbase.ts" />

module App.Common {
	'use strict';

	class CommonRoutes extends Common.RoutesBase {

		public static $inject = ['$stateProvider'];
		constructor($stateProvider: angular.ui.IStateProvider) {
			super($stateProvider);

			this.templateDir = 'Common';

			this.addState('RequestPasswordReset');

			this.addState('SignIn');
			this.addState('SetInitialPassword', { url: '/SetInitialPassword/:id/:source' });
			this.addState('ResetPassword', { url: '/ResetPassword/:id' });
			this.addState('ChangePassword');
			this.addState('NotFound', { url: null });
			this.addState('NotForWindowsAuthenticationUsers', { url: null });
			this.addState('WindowsAuthenticationAccessDenied', { url: null });
			this.addState('UserInterfaceTests');
			this.addState('NoScreenAccess', { url: null });
			this.addState('UserProfile', { url: null });
		}

	}

	angular
        .module('app.common')
		.config(['$stateProvider', ($stateProvider: angular.ui.IStateProvider) => {
			return new CommonRoutes($stateProvider);
		}]);

}
